<template>
  <div>
    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon icon="UserIcon" size="19" />
      <h4 class="mb-0 ml-50">入倉資料</h4>
    </div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <!-- Form: Personal Info Form -->
      <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          <!-- Field: Staff ID -->
          <b-col cols="12" md="12">
            <b-form-group label="入倉編號(自動生成)" label-for="id">
              <b-form-input id="id" v-model="receiptData.po_number" readonly />
            </b-form-group>
          </b-col>
          <!-- Field: Name -->

          <!-- Field: Team -->
          <b-col cols="12" md="12">
            <validation-provider
              #default="validationContext"
              name="供應商"
              rules="required"
            >
              <b-form-group label="供應商" label-for="supplier_id">
                <v-select
                  v-model="receiptData.supplier_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="supplierOptions"
                  label="name"
                  :reduce="(option) => option.id"
                  :clearable="false"
                  @input="fetchProductOptions"
                />
                <b-form-invalid-feedback
                  :state="getValidationState(validationContext)"
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: 日期 -->
          <b-col cols="12" md="12">
            <validation-provider
              #default="validationContext"
              name="日期"
              rules="required"
            >
              <b-form-group label="日期" label-for="receipt_date">
                <flat-pickr
                  v-model="receiptData.receipt_date"
                  class="form-control"
                  :config="{ dateFormat: 'Y-m-d' }"
                  placeholder="YYYY-MM-DD"
                />
                <b-form-invalid-feedback
                  :state="getValidationState(validationContext)"
                >
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Field: 備註-->
          <b-col cols="12" md="12">
            <b-form-group label="備註" label-for="remark">
              <b-form-textarea
                id="remark"
                v-model="receiptData.remark"
                placeholder="備註"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- 添加产品列表部分 -->
        <b-card-body class="invoice-padding form-item-section p-0">
          <div ref="form" class="invoice-items repeater-form">
            <b-row
              v-for="(item, index) in receiptData.items"
              :key="index"
              ref="row"
              class="pb-2"
            >
              <b-col cols="12">
                <!-- 表头 -->
                <div class="d-none d-lg-flex">
                  <b-row class="flex-grow-1 px-1">
                    <b-col cols="12" lg="6">產品</b-col>
                    <b-col cols="12" lg="2">單價</b-col>
                    <b-col cols="12" lg="2">數量</b-col>
                    <b-col cols="12" lg="2">總價</b-col>
                  </b-row>
                  <div class="form-item-action-col" />
                </div>

                <!-- 输入区域 -->
                <div class="d-flex breceipt rounded">
                  <b-row class="flex-grow-1 pt-1">
                    <b-col cols="12" lg="6">
                      <label class="d-inline d-lg-none">產品</label>
                      <v-select
                        v-model="item.product_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="productOptions"
                        label="name"
                        :reduce="(option) => option.id"
                        :clearable="true"
                        class="mb-2"
                        placeholder="選擇產品"
                        @input="(val) => updateItemForm(index, val)"
                      />
                      <!--   <b-form-textarea
                        v-model="item.description"
                        class="mb-2 mb-lg-0"
                        placeholder="產品描述"
                        rows="2"
                      /> -->
                    </b-col>

                    <b-col cols="12" lg="2">
                      <label class="d-inline d-lg-none">單價</label>
                      <b-form-input
                        v-model="item.unit_price"
                        type="number"
                        class="mb-2"
                        min="0"
                      />
                    </b-col>

                    <b-col cols="12" lg="2">
                      <label class="d-inline d-lg-none">數量</label>
                      <b-form-input
                        v-model="item.quantity"
                        type="number"
                        class="mb-2"
                        min="1"
                      />
                    </b-col>

                    <b-col cols="12" lg="2">
                      <label class="d-inline d-lg-none">總價</label>
                      <b-form-input
                        :value="item.unit_price * item.quantity"
                        type="number"
                        class="mb-2"
                        disabled
                      />
                    </b-col>
                  </b-row>

                  <div
                    class="d-flex flex-column justify-content-between breceipt-left py-50 px-25"
                  >
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer text-danger"
                      @click="removeItem(index)"
                    />
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- 添加按钮和总计 -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="primary"
            @click="addNewItemInItemForm"
          >
            新增產品
          </b-button>
          <div style="text-align: right">
            <h4>
              總計: <b>${{ total }}</b>
            </h4>
          </div>
        </b-card-body>

        <!-- Button: Submit & Reset Button.-->
        <b-row class="mt-2">
          <b-col>
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              type="submit"
            >
              儲存
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="hide"
            >
              取消
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BButton,
  BFormCheckbox,
  BFormInvalidFeedback,
  BFormTextarea,
  BCardBody,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, onMounted } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, alphaNum, email } from "@validations";

export default {
  data() {
    return {
      productOptions: [],
      itemFormBlankItem: {
        product_id: null,
        quantity: 1,
        unit_price: 0,
        remark: "",
      },
    };
  },
  computed: {
    total() {
      return (
        this.receiptData.items.reduce(
          (acc, item) => acc + item.unit_price * item.quantity,
          0
        ) || "0"
      );
    },
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BFormTextarea,
    BCardBody,
  },
  methods: {
    fetchProductOptions() {
      if (this.receiptData.supplier_id) {
        store
          .dispatch("app-receipt/fetchProductsBySupplierId", {
            supplierId: this.receiptData.supplier_id,
          })
          .then((response) => {
            this.productOptions = response.data.products;
          });
      } else {
      }
    },
    hide() {
      this.$router.replace("/stock-receive/list");
    },
    onSubmit() {
      // 準備提交數據
      const submitData = {
        id: this.receiptData.id || 0,
        receipt_date: this.receiptData.receipt_date,
        supplier_id: this.receiptData.supplier_id,
        remark: this.receiptData.remark,
        items: this.receiptData.items.map((item) => ({
          id: item.id, // 如果是編輯現有項目
          product_id: item.product_id,
          quantity: parseInt(item.quantity),
          unit_price: parseFloat(item.unit_price),
          remark: item.remark,
        })),
      };

      this.$swal({
        title: "確認儲存?",
        showCancelButton: true,
        confirmButtonText: "儲存",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          store
            .dispatch("app-receipt/addReceipt", submitData)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    addNewItemInItemForm() {
      this.receiptData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );
    },
    removeItem(index) {
      if (this.receiptData.items.length === 1) {
        this.$swal({
          text: "至少需要一個產品",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }
      this.receiptData.items.splice(index, 1);
    },
    updateItemForm(index, val) {
      if (!val) return;
      const product = this.productOptions.find((item) => item.id === val);
      console.log(product);
      if (product) {
        this.receiptData.items[index].unit_price = product.cost;
      }
    },
  },
  created() {
    // 确保 receiptData 中有 items 数组
    if (!this.receiptData.items || !this.receiptData.items.length) {
      this.$set(this.receiptData, "items", [
        JSON.parse(JSON.stringify(this.itemFormBlankItem)),
      ]);
    }
  },
  props: {
    receiptData: {
      type: Object,
      required: true,
      default: () => ({
        id: 0,
        receipt_date: "",
        supplier_id: null,
        remark: "",
        items: [],
      }),
    },
    supplierOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const resetData = () => {
      emit("refetch-data");
    };
    const resetreceiptData = () => {
      props.clientData = JSON.parse(JSON.stringify({}));
    };
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetreceiptData);

    const fetchTeamData = () => {
      store
        .dispatch("app-receipt/fetchTeams")
        .then((response) => {
          teamOptions.value = response.data.teams;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            teamOptions.value = undefined;
          }
        });
    };

    const roleOptions = ref([]);

    onMounted(() => {});

    return {
      resetData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetreceiptData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
.invoice-items {
  overflow: visible !important;
}

.invoice-padding {
  overflow: visible !important;
}

.b-form {
  overflow: visible !important;
}

.b-row {
  overflow: visible !important;
}

.b-col {
  overflow: visible !important;
}

// v-select相關樣式
.v-select {
  position: relative;
  z-index: 99 !important;
}

.vs__dropdown-menu {
  position: absolute !important;
  z-index: 999 !important;
  margin-top: 0 !important;
}

.vs__dropdown-toggle {
  z-index: 99 !important;
}

// 父容器樣式
.d-flex.breceipt {
  overflow: visible !important;
  position: relative;
  z-index: 1;
}

.form-item-section {
  overflow: visible !important;
  position: relative;
  z-index: 1;
}

.flex-grow-1.pt-1 {
  overflow: visible !important;
}

// 原有樣式
.teamleader_selected {
  background: #110f6a;
  padding: 3px 10px;
  border-radius: 3px;
  color: white;
}

// 確保下拉選單顯示在正確位置
.vs__dropdown-menu {
  top: 100% !important;
  left: 0 !important;
  width: 100% !important;
}
</style>
